import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../dto/api-response.response';
import { CompanyRequest } from '../dto/company.request';
import { CompanyResponse } from '../dto/company.response';

@Injectable({
    providedIn: 'root',
})
export class CompanyService {
    private readonly baseUrl = `${environment.apiUrl}/companies`;

    constructor(private http: HttpClient) {}

    getAll(): Observable<ApiResponse<CompanyResponse[]>> {
        return this.http.get<ApiResponse<CompanyResponse[]>>(this.baseUrl);
    }

    getById(id: number): Observable<ApiResponse<CompanyResponse>> {
        return this.http.get<ApiResponse<CompanyResponse>>(`${this.baseUrl}/${id}`);
    }

    create(req: CompanyRequest, pfxFile?: File | null, pfxPassword?: string | null, logoFile?: File | null): Observable<ApiResponse<CompanyResponse>> {
        return this.http.post<ApiResponse<CompanyResponse>>(this.baseUrl, this.toFormData(req, pfxFile, pfxPassword, logoFile));
    }

    update(id: number, req: CompanyRequest, pfxFile?: File | null, pfxPassword?: string | null, logoFile?: File | null): Observable<ApiResponse<CompanyResponse>> {
        return this.http.put<ApiResponse<CompanyResponse>>(`${this.baseUrl}/${id}`, this.toFormData(req, pfxFile, pfxPassword, logoFile));
    }

    updateStatus(id: number, status: number): Observable<ApiResponse<void>> {
        return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/status`, { status });
    }

    private toFormData(req: CompanyRequest, pfxFile?: File | null, pfxPassword?: string | null, logoFile?: File | null): FormData {
        const fd = new FormData();
        const set = (key: string, val: string | number | boolean | undefined | null) => {
            if (val !== undefined && val !== null && val !== '') fd.append(key, String(val));
        };
        set('ruc', req.ruc);
        set('businessName', req.businessName);
        set('tradeName', req.tradeName);
        set('address', req.address);
        set('ubigeo', req.ubigeo);
        set('phone', req.phone);
        set('email', req.email);
        set('website', req.website);
        set('logoUrl', req.logoUrl);
        set('status', req.status);
        set('sunatEstablishmentCode', req.sunatEstablishmentCode);
        set('sunatSecondaryUser', req.sunatSecondaryUser);
        set('sunatSecondaryUserPassword', req.sunatSecondaryUserPassword);
        set('sunatGuideId', req.sunatGuideId);
        set('sunatGuidePassword', req.sunatGuidePassword);
        set('ubigDepartment', req.ubigDepartment);
        set('ubigProvince', req.ubigProvince);
        set('ubigDistrict', req.ubigDistrict);
        set('sunatDetractionAccount', req.sunatDetractionAccount);
        // Always send booleans so Spring can bind false explicitly
        fd.append('sunatAmazoniaLaw', String(req.sunatAmazoniaLaw ?? false));
        fd.append('sunatProduction', String(req.sunatProduction ?? false));
        if (pfxFile) fd.append('pfxFile', pfxFile);
        if (pfxPassword) fd.append('pfxPassword', pfxPassword);
        if (logoFile) fd.append('logoFile', logoFile);
        return fd;
    }
}
